import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

interface ReleaseTotesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  toteNames: string[];
}

export const ReleaseTotesModal = memo(function ReleaseTotesModal({
  isOpen,
  onClose,
  onConfirm,
  toteNames,
}: ReleaseTotesModalProps) {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const toteList = toteNames.join(", ");

  return (
    <RedoModal
      isOpen={isOpen}
      onModalCloseRequested={onClose}
      subtitle="Releasing these totes will make them available for use in other pick sessions, and release any associated fulfillments that still need to be picked."
      title="Release totes"
    >
      <Flex dir="column" gap="lg" w="full">
        <Text fontSize="sm" textColor="secondary">
          {toteNames.length === 1
            ? `Tote to release: ${toteList}`
            : `Totes to release: ${toteList}`}
        </Text>
        <Flex gap="lg" justify="flex-end" w="full">
          <RedoButton
            hierarchy="secondary"
            onClick={onClose}
            size="md"
            text="Cancel"
          />
          <RedoButton
            hierarchy="primary"
            onClick={handleConfirm}
            size="md"
            text="Release totes"
          />
        </Flex>
      </Flex>
    </RedoModal>
  );
});
